import { QueryClient } from "@tanstack/react-query";
import { Chain, Transport } from "viem";
import { createConfig, fallback, http } from "wagmi";
import { injected } from "wagmi/connectors";

import "@hot-wallet/sdk/adapter/evm";
import { ARBITRUM, BASE, BSC, CHAIN_ID, ETHEREUM, LINEA } from "@/constants/chains";
import { BaseChainInfo } from "@/interfaces/config/evm";

//https://github.com/pancakeswap/pancake-frontend/blob/develop/apps/web/src/config/nodes.ts
//https://github.com/Uniswap/interface/blob/main/packages/uniswap/src/constants/chains.ts#L83
export const CHAIN_INFO: Record<CHAIN_ID, BaseChainInfo> = {
  [CHAIN_ID.BASE]: BASE,
  [CHAIN_ID.BSC]: BSC,
  [CHAIN_ID.LINEA]: LINEA,
  [CHAIN_ID.ARBITRUM]: ARBITRUM,
  [CHAIN_ID.ETHEREUM]: ETHEREUM,
} as const;

const chains = Object.values(CHAIN_INFO).map(({ chain }) => chain) as [Chain, ...Chain[]];

const transports: Record<number, Transport> = chains.reduce((ts, chain) => {
  const httpStrings = CHAIN_INFO[chain.id]?.publicNodes || [];
  const verifiedStrings =
    chain.id === 8453 ? ["https://base-mainnet.g.alchemy.com/v2/0AqEcBRdi-KR2kZ02XUMr1GVpT10ga69"] : httpStrings;

  return {
    ...ts,
    [chain.id]: fallback(verifiedStrings.map((t) => http(t))),
  };
}, {});

export const wagmiConfig = createConfig({
  chains: chains,
  connectors: [injected({ shimDisconnect: false })],
  transports,
});

export const queryClient = new QueryClient();

declare module "wagmi" {
  interface Register {
    config: typeof wagmiConfig;
  }
}
